import React from 'react';
import { SanitySlug } from '../../../lib/landingPage';
import {
    PortableText as RawPortableText,
    PortableTextProps as RawPortableTextProps,
} from '@portabletext/react';
import { LpLink } from '../../../components/landingPage/LpLink';
import { LP_LINK, isLP, isProduction } from '../../../config';

type PortableTextProps = Omit<
    RawPortableTextProps,
    'components' | 'onMissingComponent'
> & {
    components?: RawPortableTextProps['components'];
};

type InternalLinkProps = {
    value?: { slug: SanitySlug };
    children: React.ReactNode;
};

export type ExternalLinkProps = {
    value?: { blank: boolean; href: string; postSlug?: string };
    children: React.ReactNode;
};

type BasicTagProps = {
    children: React.ReactNode;
};

export function ExternalLink({ children, value }: ExternalLinkProps) {
    return (
        <a
            href={value?.href}
            rel="noopener noreferrer"
            target={value?.blank ? '_blank' : undefined}
            className="underline">
            {children}
        </a>
    );
}

function InternalLink({ children, value }: InternalLinkProps) {
    return isLP() ? (
        <LpLink className="underline" to={`/${value?.slug.current}`}>
            {children}
        </LpLink>
    ) : (
        <a
            rel="noopener noreferrer"
            target="_blank"
            href={`${LP_LINK}${value?.slug.current}`}>
            {children}
        </a>
    );
}

export function TargetBlankExternalLink(props: ExternalLinkProps) {
    return <ExternalLink {...props} value={{ ...props.value!, blank: true }} />;
}

function Paragraph({ children }: BasicTagProps) {
    return <p className="mb0">{children}</p>;
}

export const PortableText = ({
    components,
    ...props
}: PortableTextProps): JSX.Element => {
    return (
        <RawPortableText
            {...props}
            onMissingComponent={message => {
                if (!isProduction()) {
                    console.warn(message);
                }
                // log on sentry?
            }}
            components={{
                ...components,
                marks: {
                    p: Paragraph,
                    internalLink: InternalLink,
                    externalLink: ExternalLink,
                    link: ExternalLink,
                    ...components?.marks,
                },
            }}
        />
    );
};
